module.exports = __webpack_public_path__ + "static/media/icon-static-segment-grey.43f9eb17.svg";